// LIBRARIES
import styled from "styled-components";

// MISC
import { COLORS, BOXSHADOW, FONTS } from "constants/styleVariables";

export const ContainerDetails = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  // width: 100%;
  background: #F5F5F5;
  padding: 80px;
  border-radius: 24px;
  z-index: 1;
`;

export const RowWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  // justify-content: space-between;
  align-items: center;
`;

export const HoursRowWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  // justify-content: space-between;
  align-items: center;
  margin-top: 40px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  // width: 98%
`;
export const LeftContentLockerDetails = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
export const TitleStatusContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 50px;
`;

export const ContainerDetailsTitle = styled.text`
  margin-bottom: 10px;
  @media screen and (min-width: 1201px) {
    font-size: 30px;
  }
  @media screen and (max-width: 1200px) {
    font-size: 20px;
  }
  @media screen and (max-width: 800px) {
    font-size: 14px;
  }
  font-weight: bold;
  color: ${COLORS.cornflowerBlue};
  font-family: ${FONTS.newsharp};
`;

export const ContainerDetailsStatus = styled.div`
  min-width: 140px;
  font-size: 26px;
  font-weight: 600;
  color: ${COLORS.secondaryGray};
  font-family: ${FONTS.montserrat};
`;
export const ContainerAddress = styled.div`
  min-width: 140px;
`;
export const BigElementContainer = styled.div`
  display: flex;
  flex-direction: column;
  @media screen and (min-width: 1201px) {
    margin-right: 60px;
  }
  @media screen and (max-width: 1200px) {
    margin-right: 20px;
  }
`;
export const Details = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 30px;
`;
export const PriceContainer = styled.div`
  width: 200px;
`;
export const EquipmentNumberContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
export const EquipmentNumberContent = styled.div`
  width: 60px;
  margin-right: 10px;
  margin-left: 10px;
`;
export const StraightBar = styled.div`
  padding: 0 0 0 2px;
  background: ${COLORS.backgroundColor};
  margin-right: 40px;
  height: 80px;
`;
export const InformationsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
export const DetailsTitle = styled.div`
  margin-bottom: 10px;
  font-size: 20px;
  font-weight: bold;
  color: ${COLORS.cornflowerBlue};
  font-family: ${FONTS.newsharp};
`;
export const DetailsNumber = styled.div`
  font-size: 18px;
  font-weight: bold;
  color: ${COLORS.secondaryBlack};
  font-family: ${FONTS.newsharp};
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 40px;
  width: 100%;
`;

export const ButtonContainer = styled.div`
  margin: 0 20px 0 20px
`;

export const IconArrowContainer = styled.img`
  transform: rotate(90deg);
  width: 50px;
  height: 50px;
  cursor: pointer;
`;
export const DownIconArrowContainer = styled.img`
  width: 50px;
  height: 50px;
`;
export const OpenContainerDetails = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
  width: 100%; 
  background: ${COLORS.primaryWhite};
  @media screen and (min-width: 1401px) {
    // margin: -10px 80px 0 80px;
    padding: 50px 40px;
  }
  @media screen and (max-width: 1400px) {
    // margin: -10px 15px 0 15px;
    padding: 50px 20px;
  }
  border-radius: 10px;
  box-shadow: ${BOXSHADOW.containerBoxShadow};
`;
export const OpenContainerDetailsLeftContent = styled.div`
  display: flex;
  flex-direction: column;
  // align-items: flex-end;
`;
export const DateInputContainer = styled.div`
  @media screen and (min-width: 1501px) {
    margin-right: 50px;
  }
  @media screen and (max-width: 1500px) {
    margin-right: 20px;
  }
`;
export const InputContainer = styled.div`
  margin-top: 20px;
  margin-right: 50px;
  width: 220px;
`;
export const IconsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 30px;
`;
export const IconsTitle = styled.text`
  font-size: 16px;
  color: ${COLORS.secondaryBlack};
  margin-bottom: 7px;
  font-weight: 600;
  font-family: ${FONTS.montserrat};
`;
export const Icons = styled.div`
  display: flex;
  flex-direction: row;
`;
export const TurnIconContainer = styled.img`
  margin-right: 20px;
  width: 47px;
  height: 47px;
  cursor: pointer;
`;
export const PowerIconContainer = styled.img`
  width: 47px;
  height: 47px;
  cursor: pointer;
`;
export const RotatedArrowIcon = styled.img`
  width: 50px;
  height: 50px;
`;
export const ImagesContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  margin-top: 60px;
`;
export const ImageTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
export const SubtitleContainer = styled.text`
  font-size: 20px;
  font-family: ${FONTS.montserrat};
  font-weight: bold;
  color: blue;
  margin-bottom: 25px;
`;

export const SelectInputAtomContainer = styled.div`
  max-width: 220px;
  @media screen and (min-width: 1451px) {
    margin-right: 40px;
  }
  @media screen and (max-width: 1450px) {
    margin-right: 20px;
  }
`;
